import React from 'react';
import { Link } from 'react-router-dom';
import { Nav, Navbar } from 'react-bootstrap';
import styled from 'styled-components';

const Styles = styled.div`
  .navbar {
    background-color: #ffffff;
  }
  a, .navbar-brand, .navbar-nav .nav-link {
    color: #212121;
    &:hover {
      color: #212121;
    }
  }
`;

export const NavigationBar = () => (
  <Styles>
    <Navbar expand="lg">
      <Navbar.Brand href="/">
        <img
            src="https://polypods-4a1dd.web.app/static/media/polypods.7f803044.png"
            width="128"
            height="40"
            className="d-inline-block align-top"
            alt="React Bootstrap logo"
        />
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="ml-auto">
          <a className="custom-style my-auto px-3" href="https://polypods.typeform.com/to/Rlj6l7g1" target="_blank"> Nominate
         </a>
         <a className="custom-style my-auto px-3" href="https://docs.google.com/spreadsheets/d/1T_S3LtrE7NOoa9Am1gD_W2Sb8Sv-6I5dPjFTG8CYlbE/edit#gid=0" target="_blank"> Records</a>
         <a className="custom-style my-auto px-3" href="https://www.notion.so/About-Polypods-6819621e151f49b7af7b69d10aff9e99" target="_blank"> About
         </a>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  </Styles >
)